import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

const TOKEN_KEY = "inbox_marketing_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-redirect to /login on 401 (except for the login call itself)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      if (!url.includes("/auth/login")) {
        localStorage.removeItem(TOKEN_KEY);
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

// Lists
export const listLists = () => api.get("/lists").then((r) => r.data);
export const createList = (payload) => api.post("/lists", payload).then((r) => r.data);
export const getList = (id) => api.get(`/lists/${id}`).then((r) => r.data);
export const deleteList = (id) => api.delete(`/lists/${id}`).then((r) => r.data);

// Contacts
export const listContacts = (listId) => api.get(`/lists/${listId}/contacts`).then((r) => r.data);
export const bulkAddContacts = (listId, contacts) =>
  api.post(`/lists/${listId}/contacts/bulk`, { contacts }).then((r) => r.data);
export const uploadCsv = (listId, file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/lists/${listId}/contacts/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const deleteContact = (id) => api.delete(`/contacts/${id}`).then((r) => r.data);

// Campaigns
export const listCampaigns = () => api.get("/campaigns").then((r) => r.data);
export const createCampaign = (payload) => api.post("/campaigns", payload).then((r) => r.data);
export const getCampaign = (id) => api.get(`/campaigns/${id}`).then((r) => r.data);
export const updateCampaign = (id, payload) =>
  api.put(`/campaigns/${id}`, payload).then((r) => r.data);
export const deleteCampaign = (id) => api.delete(`/campaigns/${id}`).then((r) => r.data);
export const previewCampaign = (id, sample) =>
  api.post(`/campaigns/${id}/preview`, sample || {}).then((r) => r.data);
export const testCampaign = (payload) => api.post(`/campaigns/test`, payload).then((r) => r.data);
export const sendCampaign = (id) => api.post(`/campaigns/${id}/send`).then((r) => r.data);
export const campaignReport = (id) => api.get(`/campaigns/${id}/report`).then((r) => r.data);
export const campaignRecipients = (id) => api.get(`/campaigns/${id}/recipients`).then((r) => r.data);
export const syncCampaignStatus = (id) => api.post(`/campaigns/${id}/sync`).then((r) => r.data);

// Dashboard
export const dashboardStats = () => api.get("/dashboard").then((r) => r.data);

// Settings
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (payload) => api.put("/settings", payload).then((r) => r.data);
export const webhookStatus = () => api.get("/webhooks/status").then((r) => r.data);

// Agent Campaigns
export const listAgentCampaigns = () => api.get("/agent-campaigns").then((r) => r.data);
export const createAgentCampaign = (payload) =>
  api.post("/agent-campaigns", payload).then((r) => r.data);
export const getAgentCampaign = (id) => api.get(`/agent-campaigns/${id}`).then((r) => r.data);
export const updateAgentCampaign = (id, payload) =>
  api.put(`/agent-campaigns/${id}`, payload).then((r) => r.data);
export const pauseAgentCampaign = (id) => api.post(`/agent-campaigns/${id}/pause`).then((r) => r.data);
export const resumeAgentCampaign = (id) => api.post(`/agent-campaigns/${id}/resume`).then((r) => r.data);
export const deleteAgentCampaign = (id) => api.delete(`/agent-campaigns/${id}`).then((r) => r.data);
export const getAgentLeads = (id) => api.get(`/agent-campaigns/${id}/leads`).then((r) => r.data);
export const previewAgentQueries = (id) =>
  api.get(`/agent-campaigns/${id}/preview-queries`).then((r) => r.data);
export const resetAgentProgress = (id) =>
  api.post(`/agent-campaigns/${id}/reset-progress`).then((r) => r.data);
